import { render, staticRenderFns } from "./Provisioning-Suspend-Subscriber.vue?vue&type=template&id=26a953d4"
import script from "./Provisioning-Suspend-Subscriber.vue?vue&type=script&lang=js"
export * from "./Provisioning-Suspend-Subscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports